import { IFIReportType } from '@cims-online/shared'
import { useProjectSettingsContext } from '../../../../ProjectSettingsContext'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'
import { useState } from 'react'
import ConcreteTestEditPanel from './components/ConcreteTestEditPanel'
import ConcreteTestViewPanel from './components/ConcreteTestViewPanel'
import EnabledIndicator from '../../components/EnabledIndicator'
import DirtyHeader from '../../components/DirtyHeader'
import { ConcreteTestPanelName } from './types'
import { NestedCollapseProps } from '../common'

const useConcreteTestPanel = (
  collapseProps: NestedCollapseProps
): CIMSCollapsePanelOptions => {
  const {
    concreteTestIFISettings: { data },
    canEdit,
  } = useProjectSettingsContext()
  const [dirtyPanels, setDirtyPanels] = useState<ConcreteTestPanelName[]>([])

  return {
    header: {
      children: (
        <DirtyHeader
          title={IFIReportType.ConcreteTest.type}
          isDirty={dirtyPanels.length > 0}
        />
      ),
    },
    key: IFIReportType.ConcreteTest.id,
    extra: {
      children: <EnabledIndicator enabled={data?.enabled} />,
    },
    children: canEdit ? (
      <ConcreteTestEditPanel
        {...{ dirtyPanels, setDirtyPanels, ...collapseProps }}
      />
    ) : (
      <ConcreteTestViewPanel />
    ),
  }
}

export default useConcreteTestPanel
